// Carbon design motion values.
// See https://www.carbondesignsystem.com/guidelines/motion/overview/ for more info

export enum MotionDuration {
  // Micro-interactions such as button and toggle
  FAST1_70ms = 70,
  // Micro-interactions such as fade
  FAST2_110ms = 110,
  // Micro-interactions, small expansion, short distance movements
  MODERATE1_150ms = 150,
  // Expansion, system communication, toast
  MODERATE2_240ms = 240,
  // Large expansion, important system notifications
  // TODO should this be removed?
  SLOW1_400ms = 400,
  // Background dimming
  SLOW2_700ms = 700,
}

export enum MotionMode {
  /* Productive motion creates a sense of efficiency and responsiveness, while remain subtle and
    out of the way. Productive motion is appropriate for moments when the user needs to focus on 
    completing tasks. Microinteractions in Carbon such as button states, dropdowns, revealing 
    additional information, or rendering data tables and visualizations were all designed with 
    productive motion.*/
  PRODUCTIVE = 'productive',

  /* Expressive motion delivers enthusiastic, vibrant, and highly visible movement.
    Use expressive motion for significant moments such as opening a new page, 
    clicking the primary action button, or when the movement itself conveys a meaning. 
    System alerts and the appearance of notification boxes are great cases for expressive motion. */
  EXPRESSIVE = 'expressive',
}

export enum MotionName {
  // ease-in-out
  STANDARD = 'standard',
  // ease-out
  ENTRANCE = 'entrance',
  // ease-in
  EXIT = 'exit',
}
